import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = []

const cancelReasonsSlice = createSlice({
  name: 'cancelReasons',
  initialState,
  reducers: {
    areaUpdateCancelReasons: (state, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})

export const cancelReasonsActionsCreator = cancelReasonsSlice.actions

export default cancelReasonsSlice
